import * as React from 'react';

import { DataTable, Table } from '../../components/common';
import { IconButton } from '../../components/buttons';
import { IconArrowRight } from '../../components/icons';

interface Props {
	admins: UserDetails[];
	history: any;
	isLoading: boolean;
}
interface State {
	page: number;
}
class StaffList extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			page: 0
		};
	}

	onPageChange = (pageIndex: number) => {
		this.setState({ page: pageIndex });
	}

	render() {
		const { ...props } = this.props;
		return (
			<DataTable
				TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
				columns={[
					{
						Header: 'Employee Id',
						accessor: 'id'
					},
					{
						Header: 'Full Name',
						accessor: 'fullName'
					},
					{
						Header: 'Email',
						accessor: 'email'
					},
					{
						Header: 'Actions',
						className: 'p-0 td-actions',
						width: 100,
						Cell: (rowInfo: any) => {
							return (
								<IconButton
									title="Edit staff"
									className="btn-icon-secondary btn-icon-td"
									onClick={(e: any) => {
										e.stopPropagation(); // Prevent onClick conflict with tr onclick
										props.history.push(`/admin/staff/${rowInfo.row.id}/details`);
									}}
								>
									<IconArrowRight />
								</IconButton>
							);
						}
					}
				]}
				data={props.admins}
				loading={props.isLoading}
				getTrProps={(state: any, rowInfo: any, column: any) => {
					return {
						className: 'tr interactive',
						onClick: () => {
							props.history.push(`/admin/staff/${rowInfo.row.id}/details`);
						}
					};
				}}
				noDataText="No staff found"
				onPageChange={this.onPageChange}
				page={this.state.page}
			/>
		);
	}
}
export default StaffList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/staff/StaffList.tsx